// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

::ng-deep .mat-button-focus-overlay {
   background-color: transparent !important;
}

::ng-deep #reject.mat-button.mat-warn .mat-button-focus-overlay, .mat-icon-button.mat-warn .mat-button-focus-overlay, .mat-stroked-button.mat-warn .mat-button-focus-overlay {
   background-color: #f44336 !important;
   opacity: 0.04;
}

.submit-button {
   margin-left: -70px!important;
}

.list-container{
   overflow-x: auto;
   overflow-y: auto;
   max-height: 450px!important;
   max-width: 500px!important;
   padding-right: 20px!important;
}

`, "",{"version":3,"sources":["webpack://./src/app/e-signature/confirm-dialog/confirm-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,wBAAwB;AAC3B;;AAEA;GACG,wCAAwC;AAC3C;;AAEA;GACG,oCAAoC;GACpC,aAAa;AAChB;;AAEA;GACG,4BAA4B;AAC/B;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;GAChB,2BAA2B;GAC3B,0BAA0B;GAC1B,6BAA6B;AAChC","sourcesContent":["::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n::ng-deep .mat-button-focus-overlay {\n   background-color: transparent !important;\n}\n\n::ng-deep #reject.mat-button.mat-warn .mat-button-focus-overlay, .mat-icon-button.mat-warn .mat-button-focus-overlay, .mat-stroked-button.mat-warn .mat-button-focus-overlay {\n   background-color: #f44336 !important;\n   opacity: 0.04;\n}\n\n.submit-button {\n   margin-left: -70px!important;\n}\n\n.list-container{\n   overflow-x: auto;\n   overflow-y: auto;\n   max-height: 450px!important;\n   max-width: 500px!important;\n   padding-right: 20px!important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
